<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nom"
                        >Nom <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nom') }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Nom"
                        maxlength="50"
                        required
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="prenom">Prénom</label>
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('prenom') }"
                        id="prenom"
                        v-model="form.prenom"
                        type="text"
                        placeholder="Prénom"
                        maxlength="50"
                      />
                      <has-error :form="form" field="prenom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n2 mt-md-0">
                    <div class="form-group">
                      <label for="date_naissance">Date naissance</label>
                      <date-picker
                        v-model="form.date_naissance"
                        name="date_naissance"
                        placeholder="Date naissance"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_naissance'),
                        }"
                        type="hidden"
                      />
                      <has-error
                        :form="form"
                        field="date_naissance"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="lieu_naissance">Lieu naissance</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('lieu_naissance'),
                        }"
                        id="lieu_naissance"
                        v-model="form.lieu_naissance"
                        type="text"
                        placeholder="Lieu naissance"
                        maxlength="50"
                      />
                      <has-error
                        :form="form"
                        field="lieu_naissance"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="pays_naissance">Pays naissance</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('pays_naissance'),
                        }"
                        id="pays_naissance"
                        v-model="form.pays_naissance"
                        type="text"
                        placeholder="Pays naissance"
                        maxlength="50"
                      />
                      <has-error
                        :form="form"
                        field="pays_naissance"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nationalite">Nationalité</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('nationalite'),
                        }"
                        id="nationalite"
                        v-model="form.nationalite"
                        type="text"
                        placeholder="Nationalité"
                        maxlength="50"
                      />
                      <has-error :form="form" field="nationalite"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="adresse">Adresse</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('adresse'),
                        }"
                        id="adresse"
                        v-model="form.adresse"
                        type="text"
                        placeholder="Adresse"
                        maxlength="150"
                      />
                      <has-error :form="form" field="adresse"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="ville">Ville</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('ville'),
                        }"
                        id="ville"
                        v-model="form.ville"
                        type="text"
                        placeholder="Ville"
                        maxlength="50"
                      />
                      <has-error :form="form" field="ville"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="email"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('email'),
                        }"
                        id="email"
                        v-model="form.email"
                        type="text"
                        placeholder="Email"
                        maxlength="50"
                      />
                      <has-error :form="form" field="email"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="telephone">Téléphone</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('telephone'),
                        }"
                        id="telephone"
                        v-model="form.telephone"
                        type="text"
                        placeholder="Téléphone"
                        maxlength="50"
                      />
                      <has-error :form="form" field="telephone"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/candidature/candidature';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: new Form({
        nom: '',
        prenom: '',
        date_naissance: '',
        lieu_naissance: '',
        pays_naissance: '',
        ville: '',
        nationalite: '',
        adresse: '',
        email: '',
        telephone: '',
      }),
      id: null,
      VueEditorToolbar,
      title: 'Gestion des candidatures - Edition',
    };
  },
  computed: {
    ...mapGetters('candidature', ['currentCandidature', 'statuts']),
  },
  components: {
    DatePicker,
  },
  methods: {
    ...mapActions('candidature', ['setCurrentCandidature', 'setStatuts']),
    async refresh() {
      this.setCurrentCandidature(null);
      this.setStatuts([]);

      await window.axios
        .all([
          window.axios.get(URL.CANDIDATURE + '/' + this.$route.params.id, {
            params: { edit: true },
          }),
          window.axios.get(URL.GET_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentCandidature(resp1.data.candidature);
            this.setStatuts(resp2.data.statuts);
          })
        )
        .catch();

      await this.init();
    },
    init() {
      Object.assign(this.form, this.currentCandidature);
    },
    submit() {
      this.form
        .put(URL.CANDIDATURE + '/' + this.$route.params.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.refresh();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
